import { FormControl, styled } from "@tm/components"

export const FormControlFullWidth = styled(FormControl)(() => ({
    width: "100%",
}))
